// extracted by mini-css-extract-plugin
export default {"preloader":"Preloader_preloader__LVy+h","loading_rotate":"Preloader_loading_rotate__jR4WX"};